/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{min-height:100vh;margin:0 auto}mat-sidenav[_ngcontent-%COMP%]{width:80%;background:#333}.mat-drawer-content[_ngcontent-%COMP%]{overflow:initial}header[_ngcontent-%COMP%]{background:rgba(255,255,255,.4)}mat-sidenav-container.mat-drawer-container[_ngcontent-%COMP%]{background-color:transparent}"];
export { styles as styles };
